/**
 * UpsellController
 * @namespace gplans.store.controllers
 */
(function () {
  'use strict';OneTimePaymentController.$inject = ["$http", "$state", "$stateParams", "$timeout", "$localStorage", "$rootScope", "gplansConf", "Authentication", "Profile", "Mealplan", "TempCheckin", "Snackbar"];

  angular.
  module('gplans.store.controllers').
  controller('OneTimePaymentController', OneTimePaymentController);

  OneTimePaymentController.$inject = ['$http', '$state', '$stateParams', '$timeout', '$localStorage', '$rootScope', 'gplansConf', 'Authentication', 'Profile', 'Mealplan', 'TempCheckin', 'Snackbar'];


  /**
                                                                                                                                                                                                        * @namespace UpsellController
                                                                                                                                                                                                        */
  function OneTimePaymentController($http, $state, $stateParams, $timeout, $localStorage, $rootScope, gplansConf, Authentication, Profile, Mealplan, TempCheckin, Snackbar) {
    var vm = this;
    vm.onBraintreeSuccess = onBraintreeSuccess;
    vm.authorizeSubmit = authorizeSubmit;
    vm.recurlySubmit = recurlySubmit;
    vm.currency = 'USD';
    vm.order = {};
    vm.loading = false;

    activate();

    function activate() {
      vm.cost = $rootScope.user.one_time_payment;
      vm.payment_method = $localStorage['payment_method'] || 'AUTHORIZE';
    }

    function onBraintreeSuccess(response) {
      vm.braintreePaymentToken = response.nonce;
      createOrder();
    }

    function orderError(err) {
      vm.orderSubmitting = false;
      vm.loading = false;
      Snackbar.error("There was a problem processing your payment.");
    }

    function authorizeSubmit(result) {
      createOrder(result);
    }

    function recurlySubmit(result) {
      createOrder(result);
    }

    function createOrder(result) {
      var oOrder = {};
      vm.orderSubmitting = true;
      oOrder.paypal_token = vm.paypalPaymentToken;
      oOrder.braintree_token = vm.braintreePaymentToken;
      if (angular.isDefined(result)) {
        oOrder.order = {};
        oOrder.order.expiration = {};
        var expiration = result.expiry.replace(/\s/g, '').split('/');
        oOrder.order.expiration.month = expiration[0];
        oOrder.order.expiration.year = expiration[1];
        oOrder.order.cc_number = result.number;
        oOrder.order.cvv = result.cvv;
      }
      oOrder.recurly_token = true;
      Profile.createOneTimePayment(oOrder).then(orderSuccess, orderError);
    }

    function orderSuccess(res) {
      vm.orderSubmitting = false;
      vm.loading = false;
      if (res.data.success) {
        vm.orderSuccess = true;
        $timeout(function () {
          Authentication.check().then(function () {
            $state.go('gplans.userConsole');
          });
        }, 3000);
      } else
      {
        Snackbar.error("There was a problem processing your payment.");
      }
    }

    vm.getPaypalTokenRequest = function () {
      return {
        method: 'post',
        url: gplansConf.API_URL + '/api/v1/paypal/payment/create/',
        json: {
          amount: vm.cost,
          currency: vm.currency,
          description: 'One Time Payment' } };


    };

    vm.onPaypalSuccess = function (response) {
      var params = {
        payment_id: response.paymentID,
        payer_id: response.payerID };

      $http.post(gplansConf.API_URL + '/api/v1/paypal/payment/execute/',
      params).then(function (result) {
        if (result.data.success) {
          vm.paypalPaymentToken = true;
          createOrder();
        } else
        {
          vm.loading = false;
          Snackbar.error("There was a problem processing your payment.");
        }
      },
      function (err) {
        vm.loading = false;
        Snackbar.error("There was a problem processing your payment.");
      });

    };

    vm.onRecurlySuccess = function (response) {
      vm.recurlyToken = response.token;
      createOrder();
    };

  }
})();